var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-scroll-container": "" } }, [
    _c("div", { attrs: { "data-scroll-section": "" } }, [
      _c(
        "div",
        {
          staticClass: "row justify-content-center align-items-center h-100",
          class: { "mt-md-0 mt-11": _vm.$root.isDevice },
        },
        [
          _c("div", { staticClass: "col-xxl-14 col-xl-16" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-16" }, [
                _c("div", { staticClass: "row no-gutters" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xxl-8 col-lg-10 col-md-9 col-10 text-sm-justify mt-xxl-6 mt-xl-10 mt-sm-6",
                    },
                    [
                      _c("h1", { staticClass: "title text-stack" }, [
                        _vm._v("about"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "xxsmall text-stack lh-sm-20 lh-15 mt-xxl-5 mt-3",
                        },
                        [
                          _vm._v(
                            "\n                  Hi I’m Nicky a photographer based in Athens available\n                  worldwide! I originally studied architecture but I was\n                  constantly inspired by photography, a hobby that was always\n                  there but never thought of it as a profession. I realised my\n                  love for light and I quickly transitioned to the world of\n                  photography. Although I love shooting action sports and\n                  commercial work, my strongest passion is photographing\n                  people, creating stories that become visual inheritance for\n                  years to come.\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "page-links mt-10 d-lg-flex d-none" },
                        [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "contact" } } },
                                [_vm._v("work with me")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "portfolio" } } },
                                [_vm._v("view work")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xxl-5 col-xl-4 col-lg-5 col-6 offset-xl-2 offset-md-1 text-lg-left text-right",
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid pl-md-0 pl-sm-6 pl-3",
                        attrs: {
                          src: "/public/site/nickyeconomou/dist/images/about.jpg",
                          alt: "NickyEconomou",
                        },
                        on: {
                          load: function ($event) {
                            return _vm.setPageReady()
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-16 mt-lg-0 mt-3 d-lg-none" }, [
                    _c("ul", { staticClass: "page-links" }, [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "contact" } } },
                            [_vm._v("work with me")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "portfolio" } } },
                            [_vm._v("view work")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }